<template>
  <div>
    <div class='tips-text' v-if='versionId==1'>
      <a-icon type='exclamation-circle' theme='filled' :style="{color: '#ffbf00' }"/>
      <span>您尚未完成认证，认证后可解除“商品发布”等限制。如需解除限制，请点此</span>
      <a @click='goAuthentication'>立即认证</a>
    </div>
    <a-row bordered='false' style='background-color:#fff;padding-top:15px'>
      <a-col :span='2'><span class='dynamic-banner-left'>最新动态</span></a-col>
      <a-col :span='21'>
        <a-list
          :grid=' showBannerList.length<3?(showBannerList.length<2?{gutter:16,column:1}:{gutter:16,column:2}):{gutter:16,column:3}'>
          <a-list-item v-for='(item,index) in showBannerList' :key='index'>
            <span class='banner-number'>{{ index + 1 }}</span>
            <a style='color:#000;' :href='item.content' target='_blank'>{{ item.title }}</a>
          </a-list-item>
        </a-list>
      </a-col>
      <a-col :span='1'>
      <span>
      <a @click='toDynamicList()' class='dynamic-banner-right'>更多</a>
      </span>
      </a-col>
    </a-row>
    <a-card :bordered='false' style='margin-top:20px;margin-bottom:20px;'>
      <a-row class="head-info-box">
        <a-col>
          <div class='head-info head-mouse' @click='toOrderList(1)'><span>待确认</span>
            <p>{{ orderCount.unConfirmOrderCount }}<span>单</span></p></div>
        </a-col>
        <a-col v-if="showNoSendOutGoodsOrderCount">
          <div class='head-info head-mouse' @click='toOrderList(10)'><span>待发货</span>
            <p>{{ orderCount.noSendOutGoodsOrderCount }}<span>单</span></p></div>
        </a-col>
        <a-col>
          <div class='head-info head-mouse' @click='toAfterList'><span>退款/售后</span>
            <p>{{ orderCount.afterSalesOrderCount }}<span>单</span></p></div>
        </a-col>
        <!--        <a-col>-->
        <!--          <div class='head-info'><span>待签收</span>-->
        <!--            <p><span>即将上线</span></p></div>-->
        <!--        </a-col>-->
        <!-- toOrderList(100) 传100对应订单列表的undefined -->
        <a-col v-if="showNoUseOrderCount">
          <div class='head-info head-mouse' @click='toOrderList(100)'><span>待使用</span>
            <p>{{ orderCount.noUseOrderCount }}<span>单</span></p></div>
        </a-col>
        <a-col v-if="showTravelOrderCount">
          <div class='head-info head-mouse' @click='toOrderList(100)'><span>行程中</span>
            <p>{{ orderCount.travelOrderCount }}<span>单</span></p></div>
        </a-col>
      </a-row>
    </a-card>
    <a-row v-if="merchantType === 1 || merchantType === 2">
      <a-col :span='13'>
        <a-card :bordered='false' title='实时概况'>
          <span slot='extra' class='middle-title'>更新时间: {{ MerchantStatisticsData.updateTime }}</span>
          <a slot='extra' @click='toManagePandect'>数据罗盘</a>
          <a-row style='margin-bottom:20px'>
            <a-col :span='6'>
              <div class='head-info'><span>支付订单数</span>
                <p>{{ dealData.paidOrderNumber }}</p></div>
              <div style='margin-top:10px;'>昨日 {{ yesDealData.paidOrderNumber }}</div>
            </a-col>
            <a-col :span='6'>
              <div class='head-info'><span>支付金额（元）</span>
                <p>{{ dealData.paidAmount }}</p></div>
              <div style='margin-top:10px;'>昨日 <span>￥</span>{{ yesDealData.paidAmount }}</div>
            </a-col>
            <a-col :span='6'>
              <div class='head-info'><span>支付转化率</span>
                <p>{{ dealData.paymentConversionRate }}</p></div>
              <div style='margin-top:10px;'>昨日 {{ yesDealData.paymentConversionRate }}</div>
            </a-col>
            <a-col :span='6'>
              <div class='head-info'><span>客单均价</span>
                <p>{{ dealData.averageUnitPrice }}</p></div>
              <div style='margin-top:10px;'>昨日 <span>￥</span>{{ yesDealData.averageUnitPrice }}</div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span='6'>
              <div class='head-info'><span>浏览量</span>
                <p>{{ visitorData.scanNumber }}</p></div>
              <div style='margin-top:10px;'>昨日 {{ yesVisitorData.scanNumber }}</div>
            </a-col>
            <a-col :span='6'>
              <div class='head-info'><span>访客数</span>
                <p>{{ visitorData.visitorNumber }}</p></div>
              <div style='margin-top:10px;'>昨日 {{ yesVisitorData.visitorNumber }}</div>
            </a-col>
            <a-col :span='6'>
              <div class='head-info'><span>新访客</span>
                <p>{{ visitorData.newVisitorNumber }}</p></div>
              <div style='margin-top:10px;'>昨日 {{ yesVisitorData.newVisitorNumber }}</div>
            </a-col>
            <a-col :span='6'>
              <div class='head-info'><span>平均停留</span>
                <p>{{ visitorData.avgTime }}</p></div>
              <div style='margin-top:10px;'>昨日 {{ yesVisitorData.avgTime }}</div>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span='11' style='padding-left:20px;'>
        <a-card :bordered='false' style='min-height:302px;' :title='merchantName'>
          <a-row style='margin:20px 0 50px 0'>
            <a-col :span='8'>
              <div class='head-info'><span>账户余额（元）</span>
                <p class='merchant-info'><span class='merchant-info-symbol'>￥</span>{{ merchantInfo.accountTotal }}</p>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class='head-info'><span>可提现金额（元）</span>
                <p class='merchant-info'><span
                  class='merchant-info-symbol'>￥</span>{{ merchantInfo.accountAbleDrawCash }}</p></div>
            </a-col>
            <a-col :span='8'>
              <div class='head-info'><span>授信余额</span>
                <p class='merchant-info'><span class='merchant-info-symbol'>￥</span>{{ merchantInfo.accountCreditAmt }}
                </p></div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span='8'>
              <div class='head-info'><span>累计销售额</span>
                <p class='merchant-info-bottom'><span style='font-size:12px;'>￥</span>{{ merchantInfo.payAmount }}</p>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class='head-info'><span>累计用户数</span>
                <p class='merchant-info-bottom'>{{ merchantInfo.userNum }}</p></div>
            </a-col>
            <a-col :span='8'>
              <div class='head-info'><span>在售商品数</span>
                <p class='merchant-info-bottom'>{{ merchantInfo.productTotal }}</p></div>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <a-row style='margin:20px 0;'>
      <a-col :span='12' style="margin-bottom: 20px">
        <a-card :class="merchantType === 3 ? 'merchant-manage-one' : 'merchant-manage'" :bordered='false'
                title='商品管理'>
          <a slot='extra' @click='toProduct'>查看更多</a>
          <div style='margin-bottom:20px'>发布首个商品，赚取开店第一金</div>
          <!-- <div>您可使用<a>商品搬家</a>一键搬运其他平台商品至魔方云</div> -->
          <div style='margin-top:20px;'>
            <a-button @click='toProduct'>前往发布</a-button>
          </div>
        </a-card>
      </a-col>
      <a-col v-if="merchantType === 1 || merchantType === 2" :span='12' style="margin-bottom: 20px">
        <a-card :bordered='false' style='margin-left:20px;min-height:274px;' title='营销工具'>
          <a slot='extra' @click='toAllServer'>查看更多</a>
          <a-list>
            <a-list-item :key='index' v-for='(item, index) in marketData'
                         style='margin: 10px 0;padding: 10px;border: 1px solid rgba(233, 233, 233, 1);'>
              <a-list-item-meta :description='item.serverBright'>
                <a slot='title'>{{ item.orderName }}</a>
                <a-avatar style='margin-top:5px;width:42px;height:42px;' slot='avatar' size='large' shape='square'
                          :src='item.serverLogo'/>
              </a-list-item-meta>
              <div slot='actions'>
                <span @click='toMyserver'>前往创建></span>
              </div>
            </a-list-item>
          </a-list>
        </a-card>
      </a-col>
      <a-col v-if="merchantType === 1 || merchantType === 2" :span='12'>
        <a-card :bordered='false' title='蜗友商学院' style='min-height:546px'>
          <a slot='extra'>查看更多</a>
          <div style='text-align:center;margin-top:150px;font-size:24px;'>
            <a-list :dataSource='[]'/>
          </div>
        </a-card>
      </a-col>
      <a-col :span='12'>
        <a-card :bordered='false' style='margin-left:20px;min-height:546px' title='销售额类目占比'>
          <div slot='extra'>
            <a-radio-group :defaultValue='7' size='small'>
              <a-radio-button @click='getDays(item.id)' v-for='item in ratioTypeList' :key='item.id' :value='item.id'>
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </div>
          <div>
            <a-radio-group @change='onChange' :defaultValue='0'>
              <a-radio-button v-for='item in rangeTypeList' :key='item.id' :value='item.id'>{{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </div>
          <div v-if='pieData.length == 0' style='text-align:center;margin-top:173px;'>
            <a-list :dataSource='[]'/>
          </div>
          <div v-else>
            <v-chart :forceFit='false' :height='405' :width='240' :padding='5' :data='pieData' :scale='pieScale'>
              <v-legend
                :useHtml='true'
                :position='position'
                :reactive='true'
                :offsetX='10'
                :containerTpl='containerTplLegend'
                :itemTpl='itemTplLegend'
                dataKey='ratioCatalogIdName'
              ></v-legend>
              <v-guide
                type='html'
                :position="['50%','50%']"
                :html='guideHtml'
                :zIndex='2'
                :v-style="{
                fontSize: 16,
                textAlign: 'center',
                opacity: 0.75,}"/>
              <v-pie position='percent' color='ratioCatalogIdName'/>
              <v-coord type='theta' :radius='0.9' :innerRadius='0.8'/>
            </v-chart>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      title='短信提醒'
      :width='500'
      :footer='null'
      :visible='visible'
      @cancel='handleCancel'
      :maskClosable='false'
    >
      <div>{{ smsText }}</div>
    </a-modal>
    <a-modal
      title='服务到期提醒'
      :width='500'
      :footer='null'
      :visible='showServiceTips && serviceList && serviceList.length>0'
      @cancel='onCloseTipsEvent'
      :maskClosable='false'
    >
      <div v-for='(item,index) in serviceList ' :key='index'>
        <span>{{ item.name }}：剩余 <a style='color: red'>{{ item.days }}</a>天后到期</span>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { ChartCard, Trend } from '@/components'
import moment from 'moment'
import { mapState } from 'vuex'

const pieScale = [{
  dataKey: 'percent',
  min: 0,
  formatter: '.0%'
}]
export default {
  name: 'home',
  components: {
    ChartCard,
    Trend
    // Empty
  },
  data() {
    return {
      merchantName: '放假旅游网',
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      visitorData: {
        scanNumber: 0,
        visitorNumber: 0,
        newVisitorNumber: 0,
        avgTime: '00:00'
      },
      dealData: {
        paidOrderNumber: 0,
        paidAmount: 0,
        paymentConversionRate: 0,
        averageUnitPrice: 0
      },
      sourceData: [],
      yesVisitorData: {
        scanNumber: 0,
        visitorNumber: 0,
        newVisitorNumber: 0,
        avgTime: '00:00'
      },
      yesDealData: {
        paidOrderNumber: 0,
        paidAmount: 0,
        paymentConversionRate: 0,
        averageUnitPrice: 0
      },
      MerchantStatisticsData: {},
      showBannerList: [],
      marketData: [],
      orderCount: {
        unConfirmOrderCount: 0,
        noSendOutGoodsOrderCount: 0,
        afterSalesOrderCount: 0,
        noUseOrderCount: 0,
        travelOrderCount: 0
      },
      timeRadio: 2,
      channelRadio: 0,
      ratioList: [],
      merchantInfo: {
        accountTotal: 0,
        accountAbleDrawCash: 0,
        accountCreditAmt: 0,
        payAmount: 0,
        userNum: 0,
        productTotal: 0
      },
      startTime: '',
      totalAmount: '',
      endTime: '',
      position: 'right-center',
      ratioTypeList: [
        { name: '7天', id: 7 },
        { name: '30天', id: 30 }
      ],
      rangeTypeList: [
        { name: '全部渠道', id: 0 },
        { name: '平台', id: 1 },
        { name: '云仓', id: 2 }
      ],
      pieScale,
      pieData: [],
      pipStyle: {
        stroke: '#fff',
        lineWidth: 2
      },
      containerTplLegend: `<div class='g2-legend'> <table class='g2-legend-list'></table> </div>`,
      visible: false,
      smsText: '',
      showServiceTips: false,
      merchantType: '', // 商户类型 1经销商 2分销商 3供应商
      showNoSendOutGoodsOrderCount: false, // 显示<待发货>：百货类、抢购类
      showNoUseOrderCount: false, // 显示<待使用>：酒店、门票、国内跟团、出境跟团
      showTravelOrderCount: false // 显示<行程中>：国内跟团、出境跟团、自由行
    }
  },
  computed: {
    ...mapState({
      versionId: state => state.user.versionInfo.versionId
    }),
    serviceList() {
      return this.$store.getters.systemService
    }
  },
  mounted() {
    this.checkServiceTips()
    this.getDays(7)
    this.getAnnounceList()
    this.getMerchantStatisticsData()
    this.getOrderCountByStatus()
    this.getmarketData()
    this.getMerchantInformation()
    this.getSmsRemindSet()
    this.getMerchantNewField() //  获取商户新特性[类型&可售卖产品]
  },
  methods: {

    onCloseTipsEvent() {
      this.showServiceTips = false
      localStorage.setItem('mf_service_tips', JSON.stringify({ time: Date.now(), closeTips: true }))
    },
    checkServiceTips() {
      let str = localStorage.getItem('mf_service_tips')
      if (str) {
        let info = JSON.parse(str)
        const diffTime = Date.now() - info.time
        this.showServiceTips = diffTime > 24 * 60 * 60 * 1000
      } else {
        this.showServiceTips = true
      }
    },
    moment,
    handleCancel() {
      this.visible = false
      let keyValue = 'smsDialog_' + this.merchantId
      localStorage.setItem(keyValue, 'true')
    },
    getSmsRemindSet() {
      this.getHttpServices().getSmsApiService().get('sms/MerchantInfo/getSmsRemindMessage?merchantId=' + this.merchantId + '&platformId=' + this.platformId)
        .then(res => {
          let keyValue = 'smsDialog_' + this.merchantId
          if ((!localStorage.getItem(keyValue) || localStorage.getItem(keyValue) == 'false') && res) {
            this.visible = true
          }
          this.smsText = res

        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    itemTplLegend: function itemTpl(value, color, checked, index) {
      const obj = this.pieData[index]

      //判断是否打星显示
      function per() {
        if (obj.proportion == '***') {
          return '***'
        } else {
          return ((obj.percent * 100).toFixed(2) + '%')
        }
      }

      function mone() {
        if (obj.proportion == '***') {
          return '***'
        } else {
          return obj.ratioAmount
        }
      }

      const percent = per()
      const money = mone()
      checked = checked ? 'checked' : 'unChecked'
      return '<tr class="g2-legend-list-item item-' + index + ' ' + checked + '" style="padding:5px;font-size:14px;" data-value="' + value + '" data-color=' + color + ' >' + '<td style="width:100px;"><i class="g2-legend-marker" style="background-color:' + color + ';"></i>' + '<span class="g2-legend-text" style="color: #666">' + value + '</span></td>' + '<td style="width:80px;">' + percent + '</td>' + '<td style="text-align:left;color: #666;">' + '￥' + money + '</td>' + '</tr>'
    },
    //饼图自定义guide
    guideHtml: function guideTpl(value, color, checked, index) {
      const ob = this.pieData[index]
      const sum = this.totalAmount
      return '<div>' + '<div style="text-align:center;color:#aaa;">' + '销售额' + '</div>' + '<div style="font-size:20px;text-align:center;">' + '￥' + sum + '</div>' + '</div>'
    },
    //获取近7天近30天开始结束时间
    getDays(value) {
      var endTime = moment(new Date().getTime() - 3600 * 24 * 1000).format('YYYY-MM-DD')
      var startTime = moment().subtract('days', value).format('YYYY-MM-DD')
      this.startTime = startTime
      this.endTime = endTime
      this.getSalesRatioData()
      this.getLogUtils().logWithTag('this.startTime', startTime)
      this.getLogUtils().logWithTag('this.endTime', endTime)
    },
    toManagePandect() {
      this.$router.push({
        name: 'ManagePandect'
      })
    },
    toAllServer() {
      this.$router.push({
        name: 'ServiceList'
      })
    },
    toOrderList(value) {
      this.$router.push({
        name: 'OrderList',
        query: {
          orderState: value
        }
      })
    },
    toMyserver() {
      this.$router.push({
        name: 'MyService'
      })
    },
    toProduct() {
      this.$router.push({
        name: 'GoodsList'
      })
    },
    toAfterList() {
      this.$router.push({
        name: 'RefundList',
        query: {
          afterState: 0
        }
      })
    },
    //最新动态
    getAnnounceList() {
      this.getHttpServices().getUserService().get('api/v2/announce/showBanner')
        .then(detail => {
          this.showBannerList = detail.data
          this.getLogUtils().logWithTag('getAnnounceList', detail)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toDynamicList() {
      this.$router.push({
        name: 'Dynamics'
      })
    },
    //获取实时概况数据
    getMerchantStatisticsData() {
      // this.getLogUtils().logWithTag('---store---',this.$store)
      this.getHttpServices().getUserService().post('api/v2/statistics/getMerchantStatisticsData', {
        character: this.$store.getters.userInfo.merchantLoginType,
        merchantId: this.$store.getters.userInfo.merchantId,
        operatorId: this.$store.getters.userInfo.superiorBossId
      }).then(res => {
        this.MerchantStatisticsData = res
        this.visitorData = res.todayStatistics.visitorData
        this.dealData = res.todayStatistics.dealData
        this.yesVisitorData = res.yesterdayStatistics.visitorData
        this.yesDealData = res.yesterdayStatistics.dealData
        this.getLogUtils().logWithTag('实时概况', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //渠道选择框点击状态
    onChange(e) {
      this.channelRadio = e.target.value
      this.getSalesRatioData()
      this.getLogUtils().logWithTag('渠道选择', this.channelRadio)
    },
    //获取营销工具数据
    getmarketData() {
      this.getHttpServices().getServerApiService().post('service/selectMyServerHome', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        this.marketData = res
        this.getLogUtils().logWithTag('营销工具', this.marketData)
      })
    },
    //获取饼图数据
    getSalesRatioData() {
      this.pieData = []
      this.getHttpServices().getOrderService().post('api/v2/salesCategoryRatio/selectListApi', {
        endDate: this.endTime,
        merchantId: this.$store.getters.userInfo.merchantId,
        startDate: this.startTime,
        type: this.channelRadio
      })
        .then(res => {
          res.apiListVos.forEach(v => {
            v.ratioAmount = Number(v.ratioAmount)
          })
          const DataSet = require('@antv/data-set')
          const dv = new DataSet.View().source(res.apiListVos)
          dv.transform({
            type: 'percent',
            field: 'ratioAmount',
            dimension: 'ratioCatalogIdName',
            as: 'percent'
          })
          this.pieData = dv.rows
          this.totalAmount = res.totalAmount
          this.getLogUtils().logWithTag('---------------------', res)
          this.getLogUtils().logWithTag('销售额类目占比', this.pieData)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //订单数据
    getOrderCountByStatus() {
      this.getHttpServices().getOrderService().post('order/v2/OrderStatistic/getOrderCountByStatus')
        .then(res => {
          this.orderCount = res
          this.getLogUtils().logWithTag('订单量', res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //运营商数据
    getMerchantInformation() {
      this.getHttpServices().getUserService().get('backstage/homepage/get/merchantInformation')
        .then(res => {
          this.merchantInfo = res
          this.merchantName = res.merchantName
          // this.getLogUtils().logWithTag('运营商概况',res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 去立即认证页面
    goAuthentication() {
      this.$router.push({
        name: 'BasicSettings'
      })
    },
    getMerchantNewField() {
      this.getHttpServices().getApiService().post('homeMerchant/getMerchantNewField/' + this.merchantId)
        .then(res => {
          this.merchantType = res.merchantType
          if (res.productCatalogList && res.productCatalogList.length) {
            // 1门票 2酒店 3签证 4景酒 5 百货 8抢购 73出境跟团 74国内跟团 75自由行
            this.showNoSendOutGoodsOrderCount = res.productCatalogList.some(item => item === 5 || item === 8) // 显示<待发货>：百货类、抢购类
            this.showNoUseOrderCount = res.productCatalogList.some(item => item === 2 || item === 1 || item === 74 || item === 73) // 显示<待使用>：酒店、门票、国内跟团、出境跟团
            this.showTravelOrderCount = res.productCatalogList.some(item => item === 74 || item === 73 || item === 75) // 显示<行程中>：国内跟团、出境跟团、自由行
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang='less' scoped>
.tips-text {
  padding: 4px 15px;
  height: 30px;
  box-sizing: border-box;
  text-align: left;
  background: rgba(255, 251, 230, 1);
  border: 1px solid rgba(255, 229, 143, 1);
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 12px;

  span {
    margin-left: 10px;
  }
}

.dynamic-banner-left {
  position: relative;
  font-size: 16px;
  color: #FAAD14;
  //top:15px;
  padding-left: 15px;
  padding-right: 10px;
  border-right: 1px solid #ccc;
}

.dynamic-banner-right {
  position: relative;
  font-size: 14px;
  color: #FAAD14;
  //top:15px;
  padding-left: 10px;
  border-left: 1px solid #ccc;
}

.g2-legend {
  margin-bottom: 50px;
}

.middle-title {
  position: absolute;
  left: 100px;
}

.merchant-manage {
  min-height: 274px;
}

.merchant-manage-one {
  min-height: 546px;
}

.banner-number {
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  width: 20px;
  height: 20px;
  color: #3790ff;
  background-color: #ccc;
}

.head-info-box {
  display: flex;
  justify-content: space-between;
}

.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  span {
    color: rgba(0, 0, 0, .45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  p {
    color: rgba(0, 0, 0, .85);
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
}

.head-mouse:hover {
  cursor: pointer;
}

.ant-list-item-meta-description {
  font-size: 12px;
}

.merchant-info {
  font-size: 18px !important;
  color: #ff7700 !important;
  font-weight: bold;
}

.merchant-info-symbol {
  font-size: 12px !important;
  color: #ff7700 !important;
  font-weight: 400;
}

.merchant-info-bottom {
  font-size: 18px !important;
  font-weight: bold;
}
</style>